import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Flex, Box } from '@rebass/grid';

import SideItem from 'app/ui_components/SideItem';
import { H2 } from 'app/ui_components/tags';

const HeaderContainer = styled(Flex).attrs({
  mb: 32,
  width: [1 / 1],
})`
  border-width: 2px;
  border-bottom-style: solid;
  border-image: linear-gradient(to right, #f49f61, #d85c52) 2;
`;

const CountContainer = styled(Box).attrs({
  width: [1 / 2],
  p: 16,
})`
  text-align: center;
`;

const HeadCount = styled(H2)`
  color: ${({ positive }) => (positive ? '#73B567' : '#D35047')};
  font-weight: 900;
  font-size: 36px;
`;

const Label = styled.div`
  padding-top: 4px;
  font-weight: 900;
  font-size: 14px;
  font-style: italic;
`;

const CriteriaCounts = ({ passed, failed }) => (
  <SideItem justifyContent="center">
    <CountContainer>
      <HeadCount positive={false}>{failed}</HeadCount>
      <Label>Failed</Label>
    </CountContainer>
    <CountContainer>
      <HeadCount positive={true}>{passed}</HeadCount>
      <Label>Passed</Label>
    </CountContainer>
  </SideItem>
);

CriteriaCounts.propTypes = {
  passed: PropTypes.number.isRequired,
  failed: PropTypes.number.isRequired,
};

const mapStateToProps = ({
  grade: { pass_count: passed, fail_count: failed },
}) => ({ failed, passed });

export default connect(
  mapStateToProps,
  null,
)(CriteriaCounts);
